import { Node } from "@tiptap/core"

const OneLiner = Node.create({
  name: "oneLiner",
  topNode: true,
  content: "block",
})

export default OneLiner
